import { CommonModule } from "@angular/common";
import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";

export interface TabOption<T> {
  label: string;
  value: T;
}

@Component({
  selector: "tab-bar",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./tab-bar.component.html",
  styleUrls: ["./tab-bar.component.scss"],
})
export class TabBarComponent<T = unknown> implements OnInit, OnChanges {
  @Input() options: TabOption<T>[] = [];
  @Input() initialValue: T | null = null;
  @Output() onTabChanged = new EventEmitter<T>();

  @ContentChild(TemplateRef) optionTemplate?: TemplateRef<{ $implicit: TabOption<T> }>;

  activeValue: T | null = null;
  private initialized = false;

  ngOnInit() {
    this.syncActiveValue();
    this.initialized = true;
  }

  // Lets a parent drive the selected tab after init (e.g. jumping back to "Items" when an issue is
  // added from elsewhere); skipped before ngOnInit so it doesn't double-run on first bind.
  ngOnChanges(changes: SimpleChanges) {
    if (this.initialized && changes["initialValue"]) {
      this.syncActiveValue();
    }
  }

  select(value: T): void {
    this.activeValue = value;
    this.onTabChanged.emit(value);
  }

  private syncActiveValue(): void {
    this.activeValue = (this.initialValue ?? this.options?.[0]?.value) ?? null;

    if (this.activeValue === null) {
      throw new Error("TabBarComponent requires at least one option or an initialValue.");
    }
  }
}

